export default class HeaderVideo {
	constructor () {
		let thisClass = this;

		this.btnClose = document.getElementById('btn_close_video');

		let video = videojs('header_video').ready(function () {
			let player = this;

			console.log( player );

			player.on('ended', function() {
				thisClass.closeVideo( player )
			});

			player.on('playing', function () {
				if ( !document.body.classList.contains('is-header-elements-hidden') )
				{
					document.body.classList.add('is-header-elements-hidden');
				}
				player.posterImage.el_.style.display = 'none';
				player.bigPlayButton.el_.style.display = 'none';
				player.controlBar.el_.style.display = 'flex';
				thisClass.btnClose.style.display = 'block';
			});

			thisClass.btnClose.addEventListener('click', (e) => {
				player.pause();
				thisClass.closeVideo( player );
			});

		});
	}

	closeVideo ( player ) {
		if ( document.body.classList.contains('is-header-elements-hidden') )
		{
			document.body.classList.remove('is-header-elements-hidden');
		}
		player.currentTime(0);
		player.posterImage.el_.style.display = 'block';
		player.bigPlayButton.el_.style.display = 'block';
		player.controlBar.el_.style.display = 'none';
		player.textTrackDisplay.el_.style.display = 'none';
		this.btnClose.style.display = 'none';
	}

}